// modules
import { handleActions } from 'redux-actions'

// actions
import { setPatientBillingStatistics } from 'src/store/modules/patient/dashboard'

const initialState = {
  patientBillingStatistics: {}
}

export default handleActions(
  {
    [setPatientBillingStatistics](
      state,
      { payload: patientBillingStatistics }
    ) {
      return {
        ...state,
        patientBillingStatistics
      }
    }
  },
  initialState
)
